import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FontSizes, FontWeights, mergeStyleSets, PrimaryButton, ScreenWidthMinXLarge, Stack, Text } from '@fluentui/react';
import { Constants } from '@shared/utils/constants';
import { logger } from '@src/logger';
const contentStyles = mergeStyleSets({
    title: {
        fontSize: FontSizes.size20,
        fontWeight: FontWeights.semibold
    },
    container: {
        width: '560px',
        height: '216px',
        zIndex: '101',
        backgroundColor: '#FFFFFF',
        position: 'absolute',
        margin: 'auto',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        padding: '24px',
        [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '90%'
        }
    }
});
const logClickEvent = ({ userType, checkoutId })=>{
    const payload = {
        page: location.pathname,
        action: Constants.Telemetry.Action.Checkout,
        actionModifier: Constants.Telemetry.ActionModifier.RedirectButton,
        details: JSON.stringify({
            userType,
            checkoutId
        })
    };
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier,
        appName: payload.appName
    });
};
export const RedirectModal = ({ onClick, context, userType })=>{
    const checkoutId = useSelector(({ checkout })=>checkout.checkoutId);
    useEffect(()=>{
        const payload = {
            page: location.pathname,
            action: Constants.Telemetry.Action.Checkout,
            actionModifier: Constants.Telemetry.ActionModifier.RedirectModal,
            details: JSON.stringify({
                userType,
                checkoutId
            })
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    }, []);
    return /*#__PURE__*/ _jsxs(Stack, {
        className: contentStyles.container,
        verticalAlign: "space-between",
        children: [
            /*#__PURE__*/ _jsx(Stack.Item, {
                align: "start",
                children: /*#__PURE__*/ _jsx(Text, {
                    className: contentStyles.title,
                    children: context.loc('Checkout_Error_Title')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                align: "start",
                children: /*#__PURE__*/ _jsx(Text, {
                    children: context.loc('Checkout_Error_Description')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                align: "end",
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    "data-bi-id": Constants.JsllCheckout.RedirectButton,
                    onClick: ()=>{
                        onClick();
                        logClickEvent(userType);
                    },
                    children: context.loc('Checkout_Error_Button')
                })
            })
        ]
    });
};
